export const environment = {
  apiBaseUrl: 'https://proc.api.ofes.co.in/api'
};
